module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider7Post-73f93587.jpeg";